import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, normalizeClass as _normalizeClass, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "bg-white flex fd_c jc_center radius-20 w-400 h-450 radius-20 pdx-20 rel pdt-10 contact-body" }
const _hoisted_2 = ["src"]
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "flex ai_center jc_center text-24 text-b" }, "免费试用", -1)
const _hoisted_4 = { class: "flex fd_c mgt-20" }
const _hoisted_5 = { class: "flex fd_c" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "text-18 text-b" }, "企业名称", -1)
const _hoisted_7 = { class: "flex fd_c mgt-30" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "text-18 text-b" }, "手机号码", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "flex ai_center jc_center text-18 text-999 mgt-20 text-b" }, "24小时之内有专属客服联系", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.state.popupExperience)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "w h fixed bottom left zindex-99 bg-000-06 flex fd_c ai_center jc_center bg-mask form",
        onClick: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.mutationsPopupExperience && _ctx.mutationsPopupExperience(...args)), ["self"]))
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("img", {
            class: "w-30 h-30 abs cur icon-cancel-btn",
            "data-img": "./image/cancel.png",
            src: _ctx.state.imgUrl + '/index/cancel.png',
            alt: "icon",
            style: {"top":"17px","right":"17px"},
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.mutationsPopupExperience && _ctx.mutationsPopupExperience(...args)))
          }, null, 8, _hoisted_2),
          _hoisted_3,
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _hoisted_6,
              _createElementVNode("div", {
                class: _normalizeClass(["w h-60 border pdx-20 mgt-10", [_ctx.testData.company_name?'border-required':'']])
              }, [
                _withDirectives(_createElementVNode("input", {
                  class: "w h text-18",
                  type: "text",
                  placeholder: "请输入企业名称",
                  name: "company_name",
                  "data-type": "1",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.company_name) = $event))
                }, null, 512), [
                  [_vModelText, _ctx.form.company_name]
                ])
              ], 2)
            ]),
            _createElementVNode("div", _hoisted_7, [
              _hoisted_8,
              _createElementVNode("div", {
                class: _normalizeClass(["w h-60 border pdx-20 mgt-10", [_ctx.testData.mobile?'border-required':'']])
              }, [
                _withDirectives(_createElementVNode("input", {
                  class: "w h text-18",
                  type: "text",
                  placeholder: "请输入手机号码",
                  name: "mobile",
                  "data-type": "1",
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.mobile) = $event))
                }, null, 512), [
                  [_vModelText, _ctx.form.mobile]
                ])
              ], 2)
            ])
          ]),
          _createElementVNode("div", {
            class: "w h-60 radius-100 bg-primary cur mgt-30 text-18 text-b text-white inflex ai_center jc_center submit-0",
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.submit()))
          }, "提交"),
          _hoisted_9
        ])
      ]))
    : _createCommentVNode("", true)
}